import { ResultBody } from "../resultBody";
import { IdiotSolitaire } from "./idiotSolitaire";
export class IdiotResultBody extends ResultBody<IdiotSolitaire> {
 }
